import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MovimientoTramite } from './movimiento-tramite.models';

@Injectable({
  providedIn: 'root'
})
export class MovimientoTramiteService {
  url: string;
  token: string;
  endpoint = 'movimientosTramites';

  constructor(private http: HttpClient) {}

  addMovimientoTramite(
    movimientoTramite: MovimientoTramite
  ): Observable<MovimientoTramite> {
    return this.http.post<MovimientoTramite>(`${this.url}/${this.endpoint}/`, {
      ...movimientoTramite
    });
  }

  loadMovimientoTramite(): Observable<MovimientoTramite[]> {
    return this.http.get<MovimientoTramite[]>(`${this.url}/${this.endpoint}/`);
  }
}
